import React from 'react';
import { Badge, Card, Carousel, CustomModal, Typography, useGlobalContext } from 'seagull';
import { useIoContext, useStoreActions } from "../../../../../contexts";
import styles from "./TutorialVideos.module.scss";

const TutorialVideo = _ref => {
  let {
    video: {
      id,
      title,
      watched,
      duration
    }
  } = _ref;
  const {
    logBI
  } = useStoreActions();
  const globalContext = useGlobalContext();
  const {
    YoutubePlayer
  } = useIoContext();
  return /*#__PURE__*/React.createElement(Card, {
    className: styles.container,
    "data-testid": "tutorial-video",
    as: 'button',
    onClick: () => {
      globalContext.showModal({
        content: _ref2 => {
          let {
            dismissModal
          } = _ref2;

          const handleDismiss = () => {
            logBI(11216, {
              title
            });
            dismissModal();
          };

          return /*#__PURE__*/React.createElement(CustomModal, {
            onClose: handleDismiss,
            hideCloseBtn: true,
            "data-testid": "video-modal"
          }, /*#__PURE__*/React.createElement(YoutubePlayer, {
            playing: true,
            controls: true,
            url: "https://youtu.be/".concat(id),
            onStart: () => {
              logBI(11215, {
                title
              }); // set as watched & save, if not already watched
            },
            onEnded: handleDismiss
          }));
        },
        closeOnEscapeKey: true,
        closeOnClickOutside: true
      });
    }
  }, /*#__PURE__*/React.createElement(YoutubePlayer, {
    className: styles.thumbnail,
    light: true,
    height: 131,
    width: 232,
    url: "https://youtu.be/".concat(id)
  }), /*#__PURE__*/React.createElement("div", {
    className: styles.description
  }, /*#__PURE__*/React.createElement(Typography, {
    className: styles.title,
    weight: 'bold',
    ellipsis: true
  }, title), /*#__PURE__*/React.createElement("div", {
    className: styles.durationRow
  }, /*#__PURE__*/React.createElement(Typography, null, "".concat(duration, " min")), watched && /*#__PURE__*/React.createElement(Badge, {
    rounded: true,
    outlined: true,
    skin: "success"
  }, "Watched"))));
};

const TutorialVideos = () => /*#__PURE__*/React.createElement(Carousel, null, [{
  id: 'B-u4FcZ6QQk',
  title: 'Welcome to Anchor 💜',
  watched: true,
  duration: '1:06'
}, {
  id: 'GDEE7u9bsU4',
  title: 'Anchor - How it works 💜',
  watched: false,
  duration: '1:32'
}, {
  id: 'QeIUKT8F9YM',
  title: 'Setting Up Your Service Library in Anchor',
  watched: true,
  duration: '5:01'
}, {
  id: 'yBKbaPz_KnU',
  title: 'Welcome to Anchor 💜',
  watched: true,
  duration: '2:16'
}, {
  id: 'yBKbaPz_KnU',
  title: 'Welcome to Anchor 💜',
  watched: true,
  duration: '2:16'
}].map(video => /*#__PURE__*/React.createElement("div", {
  key: video.id
}, /*#__PURE__*/React.createElement(TutorialVideo, {
  video: video
}))));

export default TutorialVideos;